import * as React from 'react';

import * as styles from './AdBannerPlaceholder.css';
import { TAdBannerSizes } from '../../types';

interface IAdBannerPlaceholderProps {
  sizes: TAdBannerSizes;
  testId?: string;
}

/**
 * Резервирует место под баннер (держит размер во время SSR/загрузки рекламы — без CLS).
 */
export const AdBannerPlaceholder: React.FC<React.PropsWithChildren<IAdBannerPlaceholderProps>> = ({
  sizes,
  testId,
  children,
}) => (
  <div
    className={styles['placeholder']}
    style={{ width: sizes.width, height: sizes.height, minHeight: sizes.height }}
    data-testid={testId}
  >
    {children}
  </div>
);
